@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';
@import (reference) '../../../style.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

@fontSize: 13px;

.product-inventory {
  padding: 10px;
}

.locations-container,
.allocations-container {
  margin-bottom: 10px;
}

.locations-container-flex {
  display: flex;
  justify-content: space-between;
}

.inventory-container-flex {
  display: flex;
  justify-content: space-between;
  margin-bottom: @space-16;
}

.preferences-header {
  font-weight: 500;
}

.locations-header,
.locations-header-extended,
.allocations-header {
  font-weight: 500;
  border: 1px solid var(--grey-300);
}

.locations-body {
  max-height: 160px;
  overflow-y: auto;
}

.locations-header,
.locations-header-extended,
.locations-item,
.locations-item-extended,
.allocations-header,
.allocations-body {
  font-size: @fontSize;
  display: grid;
  align-items: center;
  border-bottom: 1px solid var(--grey-300);
  border-left: 1px solid var(--grey-300);
  border-right: 1px solid var(--grey-300);
}

.locations-header > div,
.locations-header-extended > div,
.locations-item > div,
.locations-item-extended > div,
.allocations-header > div,
.allocations-body > div,
.locations-header .grid-cell,
.locations-header-extended .grid-cell,
.locations-item .grid-cell,
.locations-item-extended .grid-cell,
.allocations-header .grid-cell,
.allocations-body .grid-cell {
  display: grid;
  padding: @space-8 @space-16;
}

.locations-header > div.centered,
.locations-header-extended > div.centered,
.locations-item > div.centered,
.locations-item-extended > div.centered,
.allocations-header > div.centered,
.allocations-body > div.centered,
.locations-header .grid-cell--centered,
.locations-header-extended .grid-cell--centered,
.locations-item .grid-cell--centered,
.locations-item-extended .grid-cell--centered,
.allocations-header .grid-cell--centered,
.allocations-body .grid-cell--centered {
  justify-content: center;
}

.locations-header > div:first-child,
.locations-header-extended > div:first-child,
.locations-item > div:first-child,
.locations-item-extended > div:first-child,
.allocations-header > div:first-child,
.allocations-body > div:first-child,
.locations-header .grid-cell:first-child,
.locations-header-extended .grid-cell:first-child,
.locations-item .grid-cell:first-child,
.locations-item-extended .grid-cell:first-child,
.allocations-header .grid-cell:first-child,
.allocations-body .grid-cell:first-child {
  display: flex;
}

.locations-header,
.locations-item {
  // last column 1px is for the hack that sets the popover near the action column
  grid-template-columns: auto 225px 75px 75px 75px 75px 1px;
}

.locations-header-extended,
.locations-item-extended {
  // last column 1px is for the hack that sets the popover near the action column
  grid-template-columns: auto 150px 100px 100px 75px 75px 75px 75px 1px;
}

.allocations-header,
.allocations-body {
  grid-template-columns: auto 300px 150px;
}

.allocations-header.allocations-with-tote,
.allocations-body.allocations-with-tote {
  grid-template-columns: auto 300px 150px 200px;
}

.locations-header,
.locations-header-extended,
.locations-footer,
.allocations-header {
  background-color: var(--grey-200);
  font-size: @fontSize;
}

.locations-footer {
  display: flex;
  padding: 5px;
  min-height: 22px;
}

.inventory-adjustment {
  display: flex;
}

.inventory-adjustment > button {
  margin-right: 10px;
}

.inventory-adjustment > button:last-child {
  margin-right: 0;
}

.toggle-and-threshold {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}

.toggle-and-threshold > div {
  display: flex;
  align-items: center;
}

.toggle-and-threshold > div:first-child {
  margin-right: 50px;
}

.inventory-header {
  display: flex;
  justify-content: space-between;
}

.inventory-header-buttons {
  display: flex;
  gap: 10px;
}

.reorder-threshold-input {
  width: 60px;
}

.allocations-title {
  padding: 20px 0 10px;
  font-weight: 500;
}

.no-allocations,
.no-locations {
  grid-template-columns: auto;
  font-style: italic;
  text-align: center;
  padding: 5px;
}

.loading-indicator {
  height: 24px;
  width: 24px;
  padding: 5px;
  margin: auto;
}

.section-title {
  border: none;
  padding-left: 0;
}

.checkbox-slider {
  margin-top: 2px;
}

.icon-wrapper {
  align-self: stretch;
}

.info-icon {
  height: 16px;
  width: 100%;
  vertical-align: middle;
  margin-right: @space-4;
  color: var(--blue-600);
}

.info-text {
  flex: 1 0 0;
}

.text-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-overflow-wrap {
  overflow: hidden;
  overflow-wrap: break-word;
}
